import _ from 'lodash'
import { Switch as cSwitch } from '@coreui/vue'
import { GChart } from 'vue-google-charts/legacy'
import { api } from '@/f1/service';
import codes from '@/f1/codes'
import moment from 'moment-timezone'
import vSelect from 'vue-select';
// https://github.com/lukes/ISO-3166-Countries-with-Regional-Codes/blob/master/all/all.csv
import { country } from './country_codes'

//restful api
import { webcastle_v2 as wc } from '@/f1/service/api';

//i18n_data
import i18n_toastr from './i18n_data'
import i18n_data from '@/component/i18n_data';

let default_item = () => {
  return {
    mode_origin : '',
    mode : 0,
    // level : 1, // 향후 사용 고려 될 수 있음
    // policy_id : 0, // 현재 백엔드에서 사용
    severity : -1, // 위험도
    severity_origin : '',
    policy : '',
    is_change : false,
  }
}

// path, paramater 만 지원
export default {
  name: 'RuleCountry',
  props: ['title', 'description', 'example', 'policy_list', 'tooltip', 'is_preview', 'use_geoip', 'agent_id', 'gchart_id', '_show_toogle_button', 'only_select','geo_reset'],
  components : { cSwitch, GChart, vSelect },
  computed: {},
  watch: {
    use_geoip() {
      this.use_geoip_custom = this.use_geoip
    },
    policy_list() {
      this.policy_list_custom = this.policy_list ? this.policy_list : []
    },
    agent_id() {
      this.load()
    },
    geo_reset(){
      this.check = this.geo_reset
      if(this.check){
        this.policy_list_custom.splice(0, this.policy_list_custom.length)
        this.update()

        this.check = false
      }
    }
  },
  data: () => {
    return {
      unknown_count : 0,
      country,
      data_list : [],
      codes,
      chart : {
        options : {
          colorAxis: { colors: ['white', 'red'], minValue: 0 }
        },
        data : [
          ['Country', 'Attack'],
          // ['Germany', 200, 10],
          // ['United States', 300],
          // ['Brazil', 400],
          // ['State', "Detect"],
          // ['RU', 100]
        ],
        settings: {
          packages: ['geochart'],
        },
      },
      item : default_item(), // 차단 혹은 탐지하는 국가 코드 리스트
      policy_list_custom : [],
      use_geoip_custom : false,
      only_select_custom : false,
      moment,
      check : true,
    }
  },
  methods: {
    // 이미 있는 정책 모드 및 위험도 변경도 업데이트 필요
    change(type='mode', p_index, value) {
      console.log(type, p_index, value)

      switch (type) {
        case 'mode':
          if(this.policy_list_custom[p_index].mode_origin === null || this.policy_list_custom[p_index].mode_origin === undefined) {
            this.policy_list_custom[p_index].mode_origin = value
          } else {
            this.item.is_change = this.policy_list_custom[p_index].mode_origin != value;
          }
          this.policy_list_custom[p_index].mode = value
          break;
        case 'severity':
          if(this.item.severity_origin === null || this.item.severity_origin === undefined) {
            this.policy_list_custom[p_index].severity_origin = value
          } else {
            this.item.is_change = this.policy_list_custom[p_index].severity_origin != value;
          }
          this.policy_list_custom[p_index].severity = value
          break;
      }

      // 최근 변경 시각 업데이트
      if(this.item.is_change) {
        if(type == 'severity') { this.policy_list_custom[p_index].last_serverity_updated_at = moment().format('YYYY-MM-DD HH:mm:ss') }
        else if(type == 'mode') { this.policy_list_custom[p_index].last_mode_updated_at = moment().format('YYYY-MM-DD HH:mm:ss') }
      }
      // 저장시 비교를 위해 업데이트
      this.update()

    },
    is_hide_check() { return !this.is_preview || this.is_preview === false },
    flags(lang='') {
      //toLowerCase() 에서 오류 발생
      //lang null check 및 '' check 하여 경우의 수 나눠줌
      if(lang == null || lang == ''){
        return `flag-icon-${lang}`;
      }else{
        return `flag-icon-${lang.toLowerCase()}`;
      }
    },
    select(geochart) {
      let selection = geochart.getSelection();
      console.log(JSON.stringify(selection))

      let data = { country : '', count : 0  }
      for (let i = 0; i < selection.length; i++) {
        var item = selection[i];
        try {
          if(item.row != null) {
            data.count = this.data_list[item.row + 1][1]
            data.country = this.data_list[item.row + 1][0]
          }
        } catch (e) { continue }
      }

      // geochart.getSelection(); // 번 해줘야 함

      console.log('country', data.country, 'count', data.count)

      if(!data.country) {
        // alert('plz, country choice')
        return;
      }
      this.item.policy = data.country
      // 정채 자동 추가
    },
    update_toggle(val) {
      this.use_geoip_custom = val
      this.$parent.$emit('update_toggle', this.use_geoip_custom)
      console.log('update_toggle', this.use_geoip_custom)
    },
    update() {
      this.$parent.$emit('update', this.policy_list_custom)
      console.log('updated')
    },
    async load_geo_info() {
      try {

        if(!this.agent_id && !this.only_select) {
          console.log("no have target agent")
          return []
        }

        // let rs = await api.webcastle.WebCastle({ target : 'log', cmd : 'summary.geo', body: { ts : new Date().getTime(), agent_id : this.agent_id }});
        let rs = await wc.detect.geo({ ts : new Date().getTime(), agent_id : this.agent_id });
        if(rs.error) { return this.$toastr.e(`${i18n_toastr._i18n_error.load_geo_info[this.i18n]}`) }

        return rs.body

      } catch (e) {
        console.log(e)
        return []
      }
    },
    remove(index=-1) {
      // if(this.is_exxist()) { return alert('already exists') }

      if(index < 0) { return alert(`${i18n_data._i18n_alert.remove_target[this.i18n]}`) }
      this.policy_list_custom.splice(index, 1)
      this.update()
    },
    append() {
      if(this.is_exxist()) { return alert(`${i18n_data._i18n_alert.exist[this.i18n]}`) }
      if(!this.use_geoip_custom) { return alert(`${i18n_toastr._i18n_alert.use_geoip_custom[this.i18n]}`) }
      if(this.item.policy.length > 2) { return alert(`${i18n_toastr._i18n_alert.require_country[this.i18n]}`) }

      this.item.policy = this.item.policy.toUpperCase()

      this.policy_list_custom.push(this.item)
      this.item = Object.assign({}, default_item())
      this.update()
    },
    is_exxist() {
      let exist = false
      for (let i = 0; i < this.policy_list_custom.length; i++) {
        if(this.policy_list_custom[i].policy == this.item.policy.trim()) { exist = true; break }
      }
      return exist
    },
    get_unknown_count() {
      try {
        let x = _.filter(this.data_list, x => !x[0])
        this.unknown_count = x.length > 0 ? x[0][1] : 0
      } catch (e) {
        console.log(e)
      }

    },
    async load() {
      try {
        // 초기 값 받기
        this.use_geoip_custom = this.use_geoip
        this.policy_list_custom = this.policy_list ? this.policy_list : []
        this.only_select_custom = this.only_select != null ? this.only_select : this.only_select_custom

        // 데이터 받기
        let result = await this.load_geo_info()
        this.data_list = JSON.parse(JSON.stringify([].concat(this.chart.data).concat(result)))
        this.get_unknown_count()

        // console.log("gchart_id", this.gchart_id, this.is_hide_check())

        if(!this.gchart_id || !this.is_hide_check()) { return }

        // 차트 생성
        google.charts.load('current', this.chart.settings);
        google.charts.setOnLoadCallback(() => {
          // console.log("gchart_id", this.gchart_id)
          // console.log(document.getElementById(this.gchart_id))
          let chart = new google.visualization.GeoChart(document.getElementById(this.gchart_id));

          google.visualization.events.addListener(chart, 'select', () => this.select(chart));

          chart.draw(google.visualization.arrayToDataTable(this.data_list), this.chart.options);
        });

      } catch (e) {
        console.log(e)
      }
    },
  },
  created: function() {
    console.log('RuleCountry.vue', 'created');
  },
  destroyed: function() {
    console.log('RuleCountry.vue', 'destroyed');
  },
  mounted: function() {
    console.log('RuleCountry.vue', 'mounted');
    this.load()
  }
}